import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import removeIcon from '../../../assets/images/deleteFile.svg';
import { isImageFile, truncateMiddle } from '../../../common';
import { FileIcon } from '../../../common/components';
import { ReplayIcon } from './ReplayIcon';
import * as styles from './Replay.module.css';
const getReplayContent = (replayMessage) => {
    let replayText = replayMessage.text;
    let replayFile = null;
    if (replayMessage.files[0]) {
        const { original_name, link } = replayMessage.files[0];
        const isImage = isImageFile(original_name);
        if (isImage) {
            const imgLink = `${link}?clientId=${replayMessage.clientId}`;
            replayFile = _jsx("img", { src: imgLink, alt: original_name, className: styles.replayImg });
            !replayText && (replayText = original_name);
        }
        if (!isImage && !replayText) {
            replayFile = (_jsx("div", { className: styles.replayFile, children: _jsx(FileIcon, {}) }));
            replayText = truncateMiddle(original_name, 23);
        }
    }
    return (_jsxs("div", { className: styles.replayContentWrapper, children: [replayFile || null, _jsx("span", { className: styles.replayText, style: { maxWidth: `calc(100% - ${replayFile ? '40px' : '0px'})` }, children: replayText })] }));
};
export const Replay = ({ replayMessage, color, removeReplay, }) => {
    if (!replayMessage)
        return null;
    return (_jsxs("div", { className: styles.replay, children: [_jsxs("div", { children: [_jsx(ReplayIcon, { color: color }), getReplayContent(replayMessage)] }), _jsx("button", { className: styles.removeButton, onClick: removeReplay, children: _jsx("img", { src: removeIcon, alt: 'remove replay', draggable: false }) })] }));
};
